$('[data-action="toggleAdminMenu"]').click(function(){
    console.log("toggle menu");
    $('.menu').toggle();
});